import styled, { css } from 'styled-components';

export const Tab = styled.span`
  font-size: ${props => (props.size ? props.size : '18px')};
  color: ${props => (props.isActive ? `${props.theme.colors.selectedColor}` : `${props.theme.colors.black}`)};
  font-weight: normal;
  font-family: ${props => (props.isActive ? props.theme.fontSets.narrow : props.theme.fontSets.narrowRegular)};
  cursor: pointer;
  line-height: 1em;
  padding-bottom: ${props => ((props.isCup || props.isTennis) ? '6px' : '0px')};
  padding-right: 0px;
  border-bottom: ${props => ((props.isCup || props.isTennis) ? props.isActive ? `3px solid ${props.theme.colors.selectedColor}` : '3px solid transparent' : '0px')};
  &:hover {
    color: ${props => props.theme.colors.selectedColor};
    font-weight: bold;
  }
  padding-top: ${props => (props.isSpecialChampionship ? '12' : '0')}px;
`;

export const TabH2 = styled.h2`
  font-size: ${props => (props.size ? props.size : '18px')};
  color: ${props => (props.isActive ? `${props.theme.colors.selectedColor}` : `${props.theme.colors.black}`)};
  font-weight: normal;
  font-family: ${props => (props.isActive ? props.theme.fontSets.narrow : props.theme.fontSets.narrowRegular)};
  cursor: pointer;
  line-height: 1em;
  padding-bottom: ${props => ((props.isCup || props.isTennis) ? '6px' : '0px')};
  padding-right: 0px;
  border-bottom: ${props => ((props.isCup || props.isTennis) ? props.isActive ? `3px solid ${props.theme.colors.selectedColor}` : '3px solid transparent' : '0px')};
  &:hover {
    color: ${props => props.theme.colors.selectedColor};
    font-weight: bold;
  }
  padding-top: ${props => (props.isSpecialChampionship ? '12' : '0')}px;
`;

export const TabWrapper = styled.li`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  ${props => (props.isCup || props.isTennis) && css`
    padding: ${props.isShort ? '0px 15px 0px 10px' : '0px 10px 0px 10px'}
  `};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    padding: ${props => ((props.isCup || props.isTennis) ? '0px 10px 0px 10px' : '0px')};
  }
  &:first-child {
    padding-left: 5px;
  }
  ${props => props.isSubPhase && css`
    &:first-child {
      padding-left: 0;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/components/CalendarTabbar/TabPanel/styles.js